import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

const ClientNameView = (props) => {
  const {
    clientData,
    setIsEditing,
  } = props;

  const clientName = clientData.clientName;
  const primaryRelationship = Object.values(clientData.relationships ?? {}).find((rel) => rel.name === clientName);
  const connectionType = primaryRelationship?.connectionType;

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Typography sx={{fontSize: '28px', fontWeight: 400}}>
        {clientName}
        {
          connectionType &&
          ` (${connectionType})`
        }
      </Typography>
    </Box>
  );
};

ClientNameView.propTypes = {
  clientData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientNameView);
